export default class Ecoswitch {

    constructor( element ) {
        this.element = element;

        this.etoggles = this.element.querySelectorAll('.switch--e li');

        this.body = document.querySelector('body');

        this.init();
        this.addEventListeners();
    }

    init() {
        if (localStorage.getItem('ecoswitch') == 'reg') {
            this.body.classList.remove('theme--eco');
            this.body.classList.add('theme--reg');
            this.etoggles.forEach( ( toggle ) =>{
                if (toggle.classList.contains('eco')) {
                    toggle.classList.remove('active');
                } else if (toggle.classList.contains('reg'))
                    toggle.classList.add('active');
            })
        } else {
            this.body.classList.remove('theme--reg');
            this.body.classList.add('theme--eco');
            
            this.etoggles.forEach( ( toggle ) =>{
                if (toggle.classList.contains('reg')) {
                    toggle.classList.remove('active');
                } else if (toggle.classList.contains('eco'))
                    toggle.classList.add('active');
            })
        }
    }

    addEventListeners() {
        this.element.addEventListener( 'click', ( event ) => { this.handleClick( event ); } ); 
    }

    handleClick( event ) {
        this.etoggles.forEach( ( toggle ) =>{
            toggle.classList.toggle('active');
        })

        this.body.classList.toggle('theme--eco');
        this.body.classList.toggle('theme--reg');

        this.toggleLocalStorage();

    }

    toggleLocalStorage() {
      
        if (localStorage.getItem('ecoswitch') == 'eco' || localStorage.getItem('ecoswitch') == null) {
            localStorage.setItem('ecoswitch', 'reg');
        } else {
            localStorage.setItem('ecoswitch', 'eco');

        }
    }


}